import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { yen, paymentLabel } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useStore } from "../lib/store";
import { ThermalReceipt } from "./ThermalReceipt";
import { ReceiptWhatsApp } from "./ReceiptWhatsApp";
import { CheckCircle2, Printer } from "lucide-react";

export const ReceiptDialog = ({ order, onClose }) => {
  const { t } = useI18n();
  const { storeName, address, phone } = useStore();
  return (
  <Dialog open={!!order} onOpenChange={() => onClose()}>
    <DialogContent className="sm:max-w-sm" data-testid="receipt-dialog">
      <DialogHeader>
        <DialogTitle className="font-display flex items-center gap-2">
          <CheckCircle2 className="text-emerald-500" size={20} /> {t("success")}
        </DialogTitle>
      </DialogHeader>
      {order && (
        <div className="space-y-4 text-sm">
          <div className="text-center pb-1">
            <p className="font-display text-lg font-semibold" data-testid="receipt-store-name">{storeName}</p>
            <p className="text-xs text-muted-foreground" data-testid="receipt-store-meta">
              {address} · {phone}
            </p>
            <p className="text-xs text-muted-foreground">{t("thanks")}</p>
          </div>
          <div className="flex justify-between text-muted-foreground">
            <span>No. {order.order_no}</span>
            <span>{new Date(order.paid_at || order.created_at).toLocaleString("id-ID")}</span>
          </div>
          {order.table_name && (
            <p className="text-muted-foreground">Meja: {order.table_name}</p>
          )}
          <div className="border-y border-dashed py-3 space-y-2">
            {order.items.map((it, i) => (
              <div key={it.product_id || `${it.name}-${i}`} className="flex justify-between gap-2">
                <span>
                  {it.name} <span className="text-muted-foreground">x{it.qty}</span>
                </span>
                <span className="num">{yen(it.price * it.qty)}</span>
              </div>
            ))}
          </div>
          <div className="space-y-1">
            <div className="flex justify-between">
              <span>{t("subtotal")}</span>
              <span className="num">{yen(order.subtotal)}</span>
            </div>
            {order.discount > 0 && (
              <div className="flex justify-between text-primary">
                <span>{t("discount")}</span>
                <span className="num">-{yen(order.discount)}</span>
              </div>
            )}
            <div className="flex justify-between font-display text-xl font-semibold pt-1">
              <span>{t("total")}</span>
              <span className="num" data-testid="receipt-total">{yen(order.total)}</span>
            </div>
            <div className="flex justify-between text-muted-foreground">
              <span>{t(`pm_${order.payment_method}`)}</span>
              <span className="num">{yen(order.paid_amount)}</span>
            </div>
            {order.change > 0 && (
              <div className="flex justify-between text-muted-foreground">
                <span>{t("change")}</span>
                <span className="num">{yen(order.change)}</span>
              </div>
            )}
          </div>
          <div className="flex gap-2">
            <Button
              variant="outline"
              className="flex-1"
              data-testid="print-receipt-btn"
              onClick={() => window.print()}
            >
              <Printer size={16} className="mr-1" /> {t("print58")}
            </Button>
            <Button className="flex-1" data-testid="close-receipt-btn" onClick={onClose}>
              {t("done")}
            </Button>
          </div>
          <ReceiptWhatsApp order={order} />
          <ThermalReceipt order={order} />
        </div>
      )}
    </DialogContent>
  </Dialog>
  );
};
